import { Checkbox, DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataEcheancier } from '../../data/DataEcheancier';
import { DataOperation_Echeancier_Stade } from '../../data/DataOperation_Echeancier_Stade';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { FicheAvancementTravauxCreation } from '../Fiche/FicheAvancementTravauxCreation';
import { FicheAvancementTravauxSuppression } from '../Fiche/FicheAvancementTravauxSuppression';
import { FicheEcheancier } from '../Fiche/FicheEcheancier/FicheEcheancier';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListEcheancier extends Component {

    static defaultProps = {
        idOperation: undefined,
        idReservation: undefined,
    };

    static defaultState = {
        groups: [],
        items: [],
        itemActif: {},
        /* --- */
        hideMessageBarFiltres: true,
        hideMessageBarWarning: true,
        hideMessageBarError: true
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        /* YD : 20221226 : inutile */
        //this._isSortedDescending = false;
        //this._sortedColumn = "nomEcheancier";
        this.state = { ...DetailsListEcheancier.defaultState };
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des échéanciers en cours..."
        });

        DataOperation_Echeancier_Stade._chargementOperation_Echeancier_Stades(this._filtres, null, false)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const stades = responseFetch.reponseAPIobjet || [];
                    /* YD : 20221226 : inutile */
                    //this._sortItems(stades);
                    const state = {
                        groups: this._getGroups(stades),
                        items: stades
                    };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                }
                else {
                    const state = { items: [] };
                    Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
                }
            });
    };

    _getColumns = () => {
        return [
            {
                fieldName: "nomStade",
                isResizable: true,
                key: "nomStade",
                name: "Stade",
            },
            {
                key: "pourcentageAvancementTravaux",
                minWidth: 100,
                maxWidth: 100,
                name: "Avancement",
                onRender: (item) => {
                    const { pourcentageAvancementTravaux } = item;
                    const title = `${parseFloat(pourcentageAvancementTravaux * 100).toFixed(10)} %`;
                    return <span title={title}>{parseFloat(pourcentageAvancementTravaux * 100).toFixed(2)}&nbsp;%</span>;
                }
            },
            {
                key: "pourcentageCumul",
                minWidth: 100,
                maxWidth: 100,
                name: "Cumul",
                onRender: (item) => {
                    const { pourcentageCumul } = item;
                    const title = `${parseFloat(pourcentageCumul * 100).toFixed(10)} %`;
                    return <span title={title}>{parseFloat(pourcentageCumul * 100).toFixed(2)}&nbsp;%</span>;
                }
            },
            {
                key: "datePrevisionnelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date prévisionnelle",
                onRender: (item) => <span>{Scriba.date().stringDateFormatCourt(item.datePrevisionnelle)}</span>
            },
            {
                key: "dateReelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date réelle",
                onRender: (item) => <span>{Scriba.date().stringDateFormatCourt(item.dateReelle)}</span>
            }
        ];
    };

    _getFarItems = () => {
        return [
            {
                key: "nombreEnregistrement",
                name: this.state.items.length
            }
        ];
    };

    _getFiltres = () => {
        const { idOperation, idReservation } = this.props;
        let filtres = {};
        if (!!idOperation) filtres.idOperation = idOperation;
        if (!!idReservation) filtres.idReservation = idReservation;
        return filtres;
    };

    _getGroups = (stades) => {
        const stadesGroupesParEcheancier = stades.reduce((memo, stade) => {
            const nomEcheancier = stade.nomEcheancier;
            if (!memo[nomEcheancier])
                memo[nomEcheancier] = [];
            memo[nomEcheancier].push(stade);
            return memo;
        }, {});

        let groups = [];
        let startIndex = 0
        for (const [nomEcheancier, stadesEcheancier] of Object.entries(stadesGroupesParEcheancier)) {
            if (stadesEcheancier.length > 0) {
                const { idEcheancier } = stadesEcheancier[0];
                const count = stadesEcheancier.length;
                groups.push({ key: idEcheancier, name: nomEcheancier, startIndex, count, isCollapsed: false });
                startIndex += count;
            }
        };

        return groups;
    };

    _getItems = () => {

        const { idOperation } = this.props;
        const { items } = this.state;

        let menuItems = [
            {
                iconProps: { iconName: "Add" },
                key: "ajouterEcheancier",
                name: "Nouvel échéancier",
                onClick: this._togglePanel("Echeancier", true, null, null)
            },
            {
                disabled: items.length <= 0,
                iconProps: { iconName: "ConstructionCone" },
                key: "avancementTravaux",
                text: "Avancement travaux",
                name: "Avancement travaux",
                subMenuProps: {
                    items: [
                        {
                            iconProps: { iconName: "Add" },
                            key: "creerAvancementTravaux",
                            onClick: this._togglePanel("AvancementTravauxCreation", true),
                            text: "Nouvel avancement travaux",
                            name: "Nouvel avancement travaux"
                        },
                        {
                            iconProps: { iconName: "Trash" },
                            key: "supprimerAvancementTravaux",
                            onClick: this._togglePanel("AvancementTravauxSuppression", true),
                            text: "Supprimer avancement travaux",
                            name: "Supprimer avancement travaux"
                        },
                    ]
                }
            },
        ];

        return menuItems;

    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender(props)}
        </Sticky>
    };

    _onRenderGroupHeader = (props, defaultRender) => {
        const onRenderTitle = (renderTitleProps, titleDefaultRender) => {
            return <Stack horizontal verticalAlign="center" horizontalAlign="space-between" styles={{ root: { width: "100%" } }}>
                {titleDefaultRender(renderTitleProps)}
                <Stack.Item>
                    <IconButton
                        iconProps={{ iconName: "Edit" }}
                        onClick={this._togglePanel("Echeancier", true, { idEcheancier: props.group.key }, false)}
                        styles={{ root: { paddingRight: "12px" } }}
                        title="Consulter/modifier l'échéancier"
                    />
                    <IconButton
                        data-testid="supprimerEcheancier"
                        iconProps={{ iconName: "Trash" }}
                        onClick={this._toggleDialog("Suppression", true, { idEcheancier: props.group.key }, false)}
                        styles={{ root: { paddingRight: "12px" } }}
                        title="Supprimer l'échéancier"
                    />
                </Stack.Item>
            </Stack>
        };
        return defaultRender({ ...props, onRenderTitle, styles: { headerCount: { display: "none" } } })
    };
    /* YD : 20221262 : 2221 - ne vois pas l'utilité si on trie correctement la source de données */
    /*_sortItems = (items) => {
        items.sort((a, b) =>
            a.nomEcheancier.localeCompare(b.nomEcheancier)
            || a.idEcheancier - b.idEcheancier
            || a.pourcentageCumul - b.pourcentageCumul
        );
    };*/
    _supprimer = () => {

        this.setState({
            afficherDialogSuppression: false,
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression de l'échéancier en cours..."
        });

        const { idOperation } = this.props;
        const { idEcheancier } = this.state.itemActif;
        DataEcheancier._onSuppressionEcheancier(idOperation, idEcheancier)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                    this._toggleDialog("Suppression", false, null, true)();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                    this._toggleDialog("Suppression", false, null, false)();
                }
            });

    };

    _toggleDialog = (nomDialog, isOpen, item, rechargerLesDonnees) => () => {
        this.setState({
            [`afficherDialog${nomDialog}`]: isOpen,
            itemActif: item || {},
        }, rechargerLesDonnees ? this._chargementDonnees : null);
    };

    _togglePanel = (nomPanel, isOpen, item, rechargerLesDonnees) => () => {
        this.setState({
            [`afficherPanel${nomPanel}`]: isOpen,
            itemActif: item || {},
        }, rechargerLesDonnees ? this._chargementDonnees : null);
    };

    componentDidMount = () => { this._chargementDonnees(); };

    componentDidUpdate = (prevProps) => {
        const { idOperation, idReservation } = this.props;
        if (prevProps.idOperation !== idOperation || prevProps.idReservation !== idReservation) {
            this._filtres = this._getFiltres();
            this._chargementDonnees();
        }
    };

    render = () => {

        const { idOperation } = this.props;
        const { afficherDialogSuppression, afficherPanelAvancementTravauxCreation, afficherPanelAvancementTravauxSuppression, afficherPanelEcheancier, itemActif } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        <DetailsList
                            columns={this._columns}
                            constrainMode={ConstrainMode.unconstrained}
                            groupProps={{
                                isAllGroupsCollapsed: false,
                                onRenderHeader: this._onRenderGroupHeader,
                            }}
                            groups={this.state.groups}
                            items={this.state.items}
                            onColumnHeaderClick={this._onClickColumnHeader}
                            onRenderDetailsHeader={this._onRenderDetailsHeader}
                            onRenderRow={this._onRenderRow}
                            //selection={this._selection}
                            selectionMode={SelectionMode.none}
                        />
                    </ScrollablePane>
                </div>
            </Stack>

            <FicheEcheancier
                idEcheancier={itemActif.idEcheancier}
                idOperation={idOperation}
                isOpen={afficherPanelEcheancier}
                onDismiss={reload => this._togglePanel("Echeancier", false, null, reload)()}
                onEnregistrement={this._togglePanel("Echeancier", false, null, true)}
            />

            <FicheAvancementTravauxCreation
                idOperation={idOperation}
                isOpen={afficherPanelAvancementTravauxCreation}
                onDismiss={this._togglePanel("AvancementTravauxCreation", false, null, false)}
                onEnregistrement={this._togglePanel("AvancementTravauxCreation", false, null, true)}
            />

            <FicheAvancementTravauxSuppression
                idOperation={idOperation}
                isOpen={afficherPanelAvancementTravauxSuppression}
                onDismiss={this._togglePanel("AvancementTravauxSuppression", false, null, false)}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton name="btnSupprimerConfirm" key="delete" onClick={this._supprimer} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("Suppression", false, null, false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppression}
                message="Confirmez-vous la suppression de cet échéancier ?"
                onDismiss={this._toggleDialog("Suppression", false, null, false)}
                titre="Suppression d'un échéancier"
            />

        </Fragment>;

    };

};